export default class {
  makeSpotPic (thumb, thing) {
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    canvas.width = 1024
    canvas.height = 1024
    context.fillStyle = '#fff'
    context.fillRect(0, 0, canvas.width, canvas.height)
    let picImage = new Image()
    picImage.src = thumb
    picImage.onload = () => {
      context.drawImage(picImage, 1024, 1024)
      let textureUp = new window.THREE.Texture(canvas)
      textureUp.needsUpdate = true
      thing.arobj.material = new window.THREE.MeshBasicMaterial({map: textureUp})
    }
    let texture = new window.THREE.Texture(canvas)
    texture.needsUpdate = true
    let material = new window.THREE.MeshBasicMaterial({map: texture})
    let mesh = new window.THREE.Mesh(
        new window.THREE.PlaneGeometry(10, 10, 1),
        material
      )
    mesh.dynamic = true
    return mesh
  }
  makeBorder () {
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('2d')
    canvas.width = 1024
    canvas.height = 1024
    context.fillStyle = '#fff'
    context.fillRect(0, 0, canvas.width, canvas.height)
    let texture = new window.THREE.Texture(canvas)
    texture.needsUpdate = true
    let material = new window.THREE.MeshBasicMaterial({map: texture})
    let mesh = new window.THREE.Mesh(
        new window.THREE.PlaneGeometry(13, 13, 1),
        material
      )
    mesh.dynamic = true
    mesh.position.z = -1
    return mesh
  }
}



// WEBPACK FOOTER //
// ./src/classes/makeSpot.js